import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { MuiThemeProvider } from "@material-ui/core";
import theme from "./theme";
import GoogleSheetsProvider from "./context/GoogleSheets";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import "react-phone-input-2/lib/material.css";

ReactDOM.render(
  <React.StrictMode>
    <MuiThemeProvider theme={theme}>
      <GoogleSheetsProvider>
        <App />
      </GoogleSheetsProvider>
    </MuiThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
